<template>
  <div class="index stick" @click="momdayPlayInitFromRoot">
    <div v-show="showNewPeople" class="new-people-wrap">
      <img
        id="newPeople"
        v-for="(img, i) of newPeopleConfig.img_list"
        :key="i"
        :src="img.img_path"
      />
    </div>
    <follow @follow="followFn" :pathType="'homePage'"></follow>
    <Scroller
      :is-finished-data.sync="finished"
      :is-loading-data.sync="loading"
      :is-refresh-data.sync="refresh"
      :style="follow ? { 'margin-top': '0.5rem' } : {}"
      :type="'infinite'"
      @on-infinite="onInfinite"
      class="my_scroller"
      ref="my_scroller"
    >
      <van-sticky
        :container="my_scroller"
        :offset-top="follow ? '0.49rem' : 0"
        @scroll="scrollTopHeader"
        class="sticky"
        v-if="stickyShow"
        z-index="200"
      >
        <header
          :class="{ headerheight: isheaderwidth }"
          :style="
            isheaderwidth
              ? {
                  background: newbannerlist.length ? newbannerlist[0].color || bg_topcolor || '#fea9ae' : bg_topcolor || '#fea9ae'
                }
              : {}
          "
          class="header"
          ref="header"
        >
          <div class="header_content">
            <span :class="{ opac: isheaderwidth }">可丽金，专研重组胶原抗老*</span>
            <div class="icon">
              <img
                @click="goSignin"
                src="/static/images/integral/signin.png"
                v-if="signinShow == 1"
              />
              <img @click="goSignin" src="/static/images/index/signin.png" v-else />
              <van-badge :dot="tagShow == 1 ? true : false">
                <img @click="goMessage" class="msg" src="/static/images/index/msg.png" />
              </van-badge>
            </div>
          </div>
          <div :class="{ headsearchwidth: isheaderwidth }" @click="searchClick" class="headsearch">
            <div class="searchicon">
              <van-icon name="search" />
            </div>
            <div class="inp over-ell-1">
              {{ defaultSearch ? '搜索“' + defaultSearch + '”' : '' }}
            </div>
          </div>
          <div :class="{ opac: isheaderwidth }" class="hot" v-if="!searchlist.length"></div>
          <ul :class="{ opac: isheaderwidth }" class="hot" v-else>
            <li @click="search(item)" v-for="item of searchlist">
              <img :src="item.img_path" v-if="item.img_path" />
              {{ item.searchtext }}
            </li>
          </ul>
        </header>
      </van-sticky>
      <div class="banner" name="banner">
        <swiper
          v-if="newbannerlist.length > 0"
          id="swiperBanner"
          :options="bannerSwiper"
          ref="bannerSwiper"
          style="height: 100%"
        >
          <swiper-slide :key="index" v-for="(item, index) of newbannerlist">
            <img
              class="of-c"
              :src="item.img_path"
              @error="
                (event) => {
                  let img = event.srcElement
                  img.src = errorImg
                  img.onerror = null
                }
              "
            />
            <div
              :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=1'"
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
            ></div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" id="bannerSwiperPagination"></div>
      </div>
      <div class="featuredads mall_endorsement" name="背书" v-if="mall_endorsement.img_path">
        <div
          style="position: relative"
          @click="bannerClick(mall_endorsement, 0, 'mall_endorsement-1')"
        >
          <img
            :src="mall_endorsement.img_path"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorImg
                img.onerror = null
              }
            "
          />
          <div
            :path="
              mall_endorsement.ad_target +
              (mall_endorsement.ad_target.indexOf('?') >= 0 ? '&' : '?') +
              'sorce=7'
            "
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (mall_endorsement.ad_type == 7 || mall_endorsement.ad_type == 8)"
          ></div>
        </div>
      </div>
      <!-- 商城首页频道专区 -->
      <home-channel-zone
        v-if="channel_zone_list.length"
        :list="channel_zone_list"
        @banner-click="bannerClick"
      ></home-channel-zone>
      <home-category-icon-swiper
        v-if="categorylist.length && isNewPage != -1"
        :categorylist="categorylist"
        :layout="isNewPage == 1 ? 'row' : 'classic'"
        @banner-click="bannerClick"
      ></home-category-icon-swiper>
      <!-- 轮播-增（商城首页分类下轮播 bannerZone） -->
      <mall-banner-carousel
        v-if="bannerZone.length"
        class="ml11 mr11 mt10"
        :list="bannerZone"
        @banner-click="bannerClick"
      ></mall-banner-carousel>
      <!-- 视频-增 -->
      <featured-momday-video
        v-if="momday_video.video_url && isNewPage == 1"
        ref="featuredMomdayVideo"
        :video="momday_video"
      ></featured-momday-video>
      <act-scroll name="公告" :notice="notice" class="ml11 mr11 mt10 mb10"></act-scroll>
      <div class="countdown" v-if="countdown.isshow > 0 && act_countdown.start_actimg">
        <img class="radius-8px" :src="countdown.isshow == 1 ? act_countdown.start_actimg : act_countdown.end_actimg" />
        <van-count-down :time="countdown.time" class="flex-js-ac" @finish="finishFn">
          <template #default="timeData">
            <div class="time flex-ac">
              <span class="colon flex-s">
                {{ timeData.days >= 10 ? timeData.days : '0' + timeData.days }}
              </span>
            </div>
            <div class="time flex-ac">
              <span class="colon flex-s">
                {{ timeData.hours >= 10 ? timeData.hours : '0' + timeData.hours }}
              </span>
            </div>
            <div class="time flex-ac">
              <span class="colon flex-s">
                {{ timeData.minutes >= 10 ? timeData.minutes : '0' + timeData.minutes }}
              </span>
            </div>
            <div class="time flex-ac">
              <span class="colon flex-s">
                {{ timeData.seconds >= 10 ? timeData.seconds : '0' + timeData.seconds }}
              </span>
            </div>
          </template>
        </van-count-down>
      </div>
      <act-calendar :actcalendar="actcalendar" @banner-click="bannerClick" class="mt10 mb10"></act-calendar>
      <act-time-limit
        :actseckill="actseckill"
        class="mt10 mb15 ml11 mr11"
        @banner-click="bannerClick"
      ></act-time-limit>
      <div class="featuredads radius-8px" name="私域导流入口" v-if="privatesphere.length">
        <div
          style="position: relative"
          v-for="item of privatesphere"
          @click="bannerClick(item, index, 'privatesphere-' + (index + 1))"
        >
          <img
            :src="item.img_path"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorImg
                img.onerror = null
              }
            "
          />
          <div
            :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=7'"
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
          ></div>
        </div>
      </div>
      <activity-stagger-swiper
        :list="activitylist"
        ref="activityStagger"
        @banner-click="bannerClick"
      ></activity-stagger-swiper>
      <act-full-gift name="满赠活动" :fullgift="fullgift" @banner-click="bannerClick" class="ml11 mr11 mt10 mb10"></act-full-gift>
      <featured-momday-video
        v-if="momday_video.video_url && isNewPage == 0"
        ref="featuredMomdayVideo"
        :video="momday_video"
      ></featured-momday-video>
      <div class="featuredads radius-8px" v-if="featuredads.length">
        <div
          style="position: relative"
          v-for="item of featuredads"
          @click="bannerClick(item, index, 'ad-' + (index + 1))"
        >
          <img
            :src="item.img_path"
            @error="
              (event) => {
                let img = event.srcElement
                img.src = errorImg
                img.onerror = null
              }
            "
          />
          <div
            :path="item.ad_target + (item.ad_target.indexOf('?') >= 0 ? '&' : '?') + 'sorce=7'"
            :username="'gh_5d4bb8e18b8b'"
            class="slide_cl_xcx"
            v-if="isWx && (item.ad_type == 7 || item.ad_type == 8)"
          ></div>
        </div>
      </div>
      <div class="featuredads" v-if="communityad.img_path">
        <div
          style="position: relative"
          :key="index"
          @click="bannerClick(communityad, 0, 'communityad-1')"
        >
          <img :src="communityad.img_path" class="slide-image errorImg radius-8px" mode="widthFix" />
        </div>
      </div>
      <div
        class="featuredads mall_endorsement"
        v-if="actGoodsAd && actGoodsAd.goodsList && actGoodsAd.goodsList.length"
      >
        <actGoodsAd :info="actGoodsAd" @banner-click="bannerClick"></actGoodsAd>
      </div>
      <home-video-goods
        v-if="videogoodslist.length"
        :list="videogoodslist"
        ref="homeVideoGoods"
        @banner-click="bannerClick"
      ></home-video-goods>
      <!-- 商城首页大图多品轮播-增 -->
      <vitality-big-multi-banner
        v-for="(item, index) of bigMultiBannerZone"
        :comp-index="index"
        v-if="item.bannerList && item.bannerList.length"
        :info="item"
        @banner-click="bannerClick"
      ></vitality-big-multi-banner>
      <!-- 首页分类专区-增 -->
      <home-category-zone
        v-for="(item, index) of categoryZone"
        v-if="item.goodsList && item.goodsList.length"
        :zone="item"
        :flow_area_prefix="'categoryZone-' + (index + 1)"
        @banner-click="bannerClick"
      ></home-category-zone>
      <!-- 首页分类产品货架专区-增 -->
      <home-goods-shelf-zone
        v-for="(item, index) of goodsShelfZone"
        v-if="item.groupList.length > 0"
        :zone="item"
        :flow_area_prefix="'goodsShelfZone-' + (index + 1)"
        @banner-click="bannerClick"
      ></home-goods-shelf-zone>
      <div class="series" name="手风琴分类专区">
        <van-collapse v-model="seriesNames">
          <van-collapse-item
            ref="collapseItem"
            v-for="(item, index) of serieslist"
            :key="index"
            :name="index"
          >
            <template slot="title">
              <div class="title">
                <img
                  class="radius-8px"
                  :src="item.banner_img"
                  @click="
                    $clickburiedPoint({
                      data: {
                        buttonCode: 'class-' + (index + 1),
                        buttontext: item.name
                      }
                    })
                  "
                  @error="
                    (event) => {
                      let img = event.srcElement
                      img.src = errorImg
                      img.onerror = null
                    }
                  "
                />
              </div>
            </template>
            <div class="seriesgoods" v-if="item.goodslist.length">
              <swiper id="seriesBanner" :options="seriesSwiper" style="height: 100%">
                <swiper-slide
                  ref="activityItem"
                  v-for="(itemSon, indexSon) of item.goodslist"
                  :key="indexSon"
                >
                  <img
                    :src="itemSon.goods_img"
                    class="radius-8px"
                    @click="goDetail(itemSon, indexSon, 'classprod-' + itemSon.item_id, item.name)"
                    @error="
                      (event) => {
                        let img = event.srcElement
                        img.src = errorImg
                        img.onerror = null
                      }
                    "
                  />
                </swiper-slide>
                <div slot="pagination" class="swiper-pagination seriesSwiperPagination"></div>
              </swiper>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <!-- 首页活动组-增 -->
      <home-activity-zone
        v-for="(item, index) of activityZone"
        :zone="item"
        :comp-index="index"
        @banner-click="bannerClick"
        :product="activityZone.length - 1 == index ? activityZoneProduct : {}"
        :flow_area_prefix="'activityZone-' + (index + 1)"
        :markPointData="{
          scenepoint: 'MAIN',
          scenedesc: salseranknavlist.length > 0 ? salseranknavlist[salserank].tagname : '',
          scenefrom: 'itemclass-' + (salserank + 1)
        }"
      ></home-activity-zone>
      <div
        class="salserank" name="首页推荐-改"
        v-if="salseranknavlist.length"
        :class="{ salserankBack: isFixedSalserank,'salserank-empty': salseranknavlist.length == 1 }"
        :style="salseranknavlist.length ? { 'min-height': salserankheight / 100 + 'rem' } : {}"
      >
        <van-tabs
          v-model="salserank"
          @click="salserankClick"
          z-index="200"
          :ellipsis="false"
          :sticky="salseranknavlist.length > 1"
          :offset-top="follow ? '0.89rem' : '0.4rem'"
          @scroll="scrollTopSalserank"
        >
          <van-tab
            v-for="(item, index) in salseranknavlist"
            :key="index"
            :disabled="index != salserank && tabDisabled"
          >
            <template #title>
              <div class="salseranknav">
                <p class="f15">{{ item.tagname }}</p>
                <span class="f11">{{ item.tagsubtitle }}</span>
              </div>
            </template>
          </van-tab>
          <div class="list" ref="list">
            <div class="listItem" ref="listItem1">
              <product-item
                v-for="(item, index) of salseranklist1"
                :key="index"
                :prolistItem="item"
                :prolistIndex="index"
                :type="'lazyloading'"
                :skuSwitch="'1'"
                @showSku="showSku"
                :markPointData="{
                  scenepoint: 'MAIN',
                  scenedesc: salseranknavlist[salserank].tagname,
                  scenefrom: 'itemclass-' + (salserank + 1)
                }"
              ></product-item>
            </div>
            <div class="listItem" ref="listItem2">
              <product-item
                v-for="(item, index) of salseranklist2"
                :key="index"
                :prolistItem="item"
                :prolistIndex="index"
                :type="'lazyloading'"
                :skuSwitch="'1'"
                @showSku="showSku"
                :markPointData="{
                  scenepoint: 'MAIN',
                  scenedesc: salseranknavlist[salserank].tagname,
                  scenefrom: 'itemclass-' + (salserank + 1)
                }"
              ></product-item>
            </div>
          </div>
        </van-tabs>
      </div>
    </Scroller>
    <div class="floatBtn" v-show="!showsku">
      <img @click="goquan" src="/static/images/quan.png" v-if="showquan == true" />
      <img v-if="stickShow" @click="stick" src="../../assets/images/stick.png" />
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
      <img v-if="is_private" @click="groupQr" src="/static/images/groupicon.png" />
      <img @click="keFu" src="../../assets/images/service1.png" />
    </div>
    <div
      class="floatadvert"
      :style="{
        width: +privatefloat.width / 100 + 'rem',
        height: +privatefloat.height / 100 + 'rem',
        top: (2.54 - (+privatefloat.height / 100)) + 'rem'
      }"
      v-if="privatefloat.img_path"
      @click="bannerClick(privatefloat, 0, 'mainfloat')"
      @touchstart="dragStart"
      @touchmove="dragMove"
      @touchend="dragEnd"
    >
      <img
        :style="{
          width: +privatefloat.width / 100 + 'rem',
          height: +privatefloat.height / 100 + 'rem'
        }"
        :src="privatefloat.img_path"
      />
    </div>
    <footer-comp v-if="isNewPage != -1" v-show="!showsku" :isNewPage="isNewPage" :footer-index="index" :cartnum="cartnum"></footer-comp>
    <!--非特殊通用弹窗-->
    <van-overlay :show="is_pop" v-if="is_pop && popup_ads && popup_ads.img_path" z-index="99999">
      <div class="wrapper" @click="closeAct">
        <div class="block icon_close_right" @click.stop>
          <van-icon v-if="popup_ads.closeBtnHide != 1" name="close" @click="closeAct" />
          <div style="position: relative">
            <img :src="popup_ads.img_path" @click="goAct('indexpopup')" />
            <div v-if="popup_ads.pop_type == 'yearReportPop' && popup_ads.username" class="f11 color-F pos-a" style="left: 0.35rem;top: 0.11rem;">@{{ popup_ads.username }}</div>
            <div
              :path="
                popup_ads.ad_target +
                (popup_ads.ad_target.indexOf('?') >= 0 ? '&' : '?') +
                'sorce=9'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="isWx && (popup_ads.ad_type == 7 || popup_ads.ad_type == 8)"
            ></div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!--新人折扣福利弹窗（弹窗链最高优先级，单图+正下方关闭按钮）-->
    <van-overlay :show="ndiscountWelfareShow" v-if="ndiscountWelfareShow" z-index="99999">
      <div class="wrapper" @click="closeNdiscountWelfare">
        <div class="block" @click.stop>
          <div style="position: relative">
            <img :src="ndiscount_welfare.img" @click="goNdiscountWelfare" />
          </div>
          <van-icon name="close" @click="closeNdiscountWelfare" />
        </div>
      </div>
    </van-overlay>
    <!--至臻券-->
    <van-overlay :show="showCoupon" v-if="showCoupon" z-index="99999">
      <div class="pop-wrap">
        <div class="content-wrap">
          <img class="logo" src="../../assets/images/coupon-btn.png" />
          <p class="name">至臻券</p>
          <p class="label">产品券已放到“我的-产品券”中，请尽快去使用吧！</p>
          <div class="footer-wrap">
            <div class="btn-see" @click="goCouponList">去看看</div>
            <div class="btn-buy" @click="goShopping">去下单</div>
          </div>
        </div>
        <van-icon name="close" @click="closeCoupon" />
      </div>
    </van-overlay>
    <!--企微二维码-->
    <van-overlay :show="showcoupon0326" v-if="showcoupon0326" z-index="99999">
      <div class="wrapper">
        <div class="block icon_close_right">
          <van-icon @click="showcoupon0326 = false" name="close" />
          <div style="position: relative">
            <img
              :src="specialPopJSON.popads.pop_img_url"
              @click="specialPopFn(specialPopJSON.popads)"
            />
            <div
              :path="
                specialPopJSON.popads.pop_ad_target +
                (specialPopJSON.popads.pop_ad_target.indexOf('?') >= 0 ? '&' : '?') +
                'sorce=12'
              "
              :username="'gh_5d4bb8e18b8b'"
              class="slide_cl_xcx"
              v-if="
                isWx &&
                (specialPopJSON.popads.pop_ad_type == 7 || specialPopJSON.popads.pop_ad_type == 8)
              "
            ></div>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 2021-11-26 短信通知弹窗 -->
    <van-overlay :show="issmspop.ispop == 1" v-if="issmspop && issmspop.ispop" z-index="99999">
      <div class="wrapper">
        <div class="block">
          <div class="back_write">
            <img src="/static/images/sms/bg.png" />
            <div class="text">
              <img src="/static/images/sms/notify.png" />
              亲爱的金粉，为了方便您及时参与福利活动，活动特惠期会为您推送短信通知
            </div>
            <button @click="gosms(1)">立即开启</button>
            <p @click="gosms(0)">下次再说</p>
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 2025-4-17 订单待支付弹窗 -->
    <van-overlay
      :show="orderwaitpay_pop.ispop == 1"
      v-if="orderwaitpay_pop && orderwaitpay_pop.ispop"
      z-index="99999"
    >
      <div class="wrapper customPd">
        <div class="block icon_close_right" @click.stop>
          <van-icon name="close" @click="closeWaitPay" />
          <div class="bg-F">
            <div class="content ta-c pt10 pl0 pr0">
              <div class="f17 color-3 fw-b pt0 pb0">
                您有{{ orderwaitpay_pop.hasMore == 1 ? '多' : '一' }}笔订单待支付
              </div>
              <div class="f12 color-3 mt10 pt0 pb0">
                {{
                  orderwaitpay_pop.discountMoney > 0
                    ? '该订单已优惠¥' + orderwaitpay_pop.discountMoney + ', '
                    : ''
                }}订单即将关闭
              </div>
              <div
                class="pt0 pb0 pl0 pr0 product flex jc-sb ai-c mt16 pos-r"
                @click="detailsClick(orderwaitpay_pop.orderInfo)"
              >
                <div
                  v-if="
                    orderwaitpay_pop.orderInfo.itemlist &&
                    orderwaitpay_pop.orderInfo.itemlist.length <= 1 &&
                    orderwaitpay_pop.orderInfo.itemlist.length > 0
                  "
                  class="productBox pt10 pb10 pl6 pr6 flex"
                >
                  <div class="pt0 pb0 pl0 pr0 img pos-r">
                    <img v-lazy="orderwaitpay_pop.orderInfo.itemlist[0].img_path" />
                    <goods-tag
                      class="pt0 pb0 pl0 pr0 goods_tag"
                      :goods="orderwaitpay_pop.orderInfo.itemlist[0]"
                    ></goods-tag>
                  </div>
                  <div class="proContent pt0 pb0 pl0 pr0 ml7 mt8 flex-1">
                    <b
                      class="f13 font_w-n d-b mb5 ta-l"
                      v-text="
                        orderwaitpay_pop.orderInfo.itemlist[0].name.length > 14
                          ? orderwaitpay_pop.orderInfo.itemlist[0].name.slice(0, 14) + '...'
                          : orderwaitpay_pop.orderInfo.itemlist[0].name
                      "
                    ></b>
                    <p class="ai-fs">
                      <b
                        class="f11 font_w-n d-b ta-l"
                        v-text="orderwaitpay_pop.orderInfo.itemlist[0].spec"
                      ></b>
                    </p>
                  </div>
                </div>
                <div
                  v-if="
                    orderwaitpay_pop.orderInfo.itemlist &&
                    orderwaitpay_pop.orderInfo.itemlist.length > 1
                  "
                  class="bestSellingSwiper pt0 pb0 pl0 pr0 over-h pos-r w-100"
                >
                  <swiper class="pt0 pb0 pl0" :options="swiperOption" ref="mySwiper">
                    <swiper-slide
                      v-for="(itemSon, idx) of orderwaitpay_pop.orderInfo.itemlist"
                      :key="idx"
                      class="pt0 pb0 pl0 pr0"
                    >
                      <div class="img pt0 pb0 pl0 pr0 pos-r">
                        <!--                    <div class="tag" v-if="itemSon.ispresale == 1">-->
                        <!--                      <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>-->
                        <!--                    </div>-->
                        <img v-lazy="itemSon.img_path" />
                        <goods-tag class="pt0 pb0 pl0 pr0 goods_tag" :goods="itemSon"></goods-tag>
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
                <span
                  class="totalPrice"
                  :style="
                    orderwaitpay_pop.orderInfo &&
                    orderwaitpay_pop.orderInfo.itemlist &&
                    orderwaitpay_pop.orderInfo.itemlist.length > 1
                      ? {}
                      : { position: 'static' }
                  "
                  :class="{
                    totalPriceNoShadow:
                      orderwaitpay_pop.orderInfo.itemlist &&
                      orderwaitpay_pop.orderInfo.itemlist.length < 4,
                    totalPriceShadow:
                      orderwaitpay_pop.orderInfo.itemlist &&
                      orderwaitpay_pop.orderInfo.itemlist.length >= 4
                  }"
                >
                  <span class="price">
                    {{
                      String(parseFloat(orderwaitpay_pop.orderInfo.ordermoney).toFixed(2)).slice(
                        0,
                        String(
                          parseFloat(orderwaitpay_pop.orderInfo.ordermoney).toFixed(2)
                        ).indexOf('.')
                      )
                    }}
                    <i>
                      {{
                        String(parseFloat(orderwaitpay_pop.orderInfo.ordermoney).toFixed(2)).slice(
                          String(
                            parseFloat(orderwaitpay_pop.orderInfo.ordermoney).toFixed(2)
                          ).indexOf('.'),
                          String(parseFloat(orderwaitpay_pop.orderInfo.ordermoney).toFixed(2))
                            .length
                        )
                      }}
                    </i>
                  </span>
                  <b>共{{ orderwaitpay_pop.orderInfo.item_nums }}件</b>
                </span>
              </div>
            </div>
            <div class="flex jc-sa">
              <van-button
                class="pl0 pr0"
                round
                type="info"
                size="small"
                plain
                color="#FC0324"
                @click="closeWaitPay(1)"
                style="width: 1.04rem"
              >
                今日不再提醒
              </van-button>
              <van-button
                class="pl0 pr0 ws-n"
                round
                type="info"
                size="small"
                color="#FC0324"
                @click="goBuy()"
                style="width: 1.04rem"
              >
                {{ orderwaitpay_pop.hasMore == 1 ? '其他待支付订单' : '立即支付' }}
              </van-button>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>

    <!--2025-8-28 新增红包雨弹窗-->
    <red-packets-rain-pop ref="redPacketsRainPop"></red-packets-rain-pop>
  </div>
</template>

<script>
import productItem from '../common/productItem'
import footerComp from '../common/footerComp'
import follow from '../common/follow'
import Scroller from '../common/Scroller'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import '../../assets/css/zy.media.css'
import zymedia from '../../assets/js/zy.media'
import {
  fenxiang,
  getCookie,
  isWeixin,
  kefu,
  qrcodeKefuLimits,
  setCookie,
  popType,
  clearPopCache,
  bannerClick,
  goXcxCreateBtnFn,
  download_dialog,
  checkAgent
} from '../../assets/common/js/config'
import actGoodsAd from './components/actGoodsAd'
import actScroll from './components/actScroll'
import actCalendar from './components/actCalendar.vue'
import actTimeLimit from './components/actTimeLimit.vue'
import actFullGift from './components/actFullGift.vue'
import activityStaggerSwiper from './components/activityStaggerSwiper.vue'
import homeVideoGoods from './components/homeVideoGoods.vue'
import featuredMomdayVideo from './components/featuredMomdayVideo.vue'
import vitalityBigMultiBanner from './components/vitalityBigMultiBanner.vue'
import mallBannerCarousel from './components/mallBannerCarousel.vue'
import homeCategoryZone from './components/homeCategoryZone.vue'
import homeGoodsShelfZone from './components/homeGoodsShelfZone.vue'
import homeActivityZone from './components/homeActivityZone.vue'
import homeChannelZone from './components/homeChannelZone.vue'
import homeCategoryIconSwiper from './components/homeCategoryIconSwiper.vue'
import { Swipe, SwipeItem } from 'vant'
import goodsTag from '../common/goodsTag'
import redPacketsRainPop from '../common/redPacketsRainPop.vue'
import Vue from 'vue'

Vue.use(VueAwesomeSwiper /* { default global options } */).use(Swipe).use(SwipeItem)
Vue.config.ignoredElements = ['wx-open-launch-weapp']
export default {
  name: 'homePage',
  components: {
    productItem,
    footerComp,
    follow,
    Scroller,
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide,
    actGoodsAd,
    actScroll,
    actCalendar,
    actTimeLimit,
    actFullGift,
    activityStaggerSwiper,
    homeVideoGoods,
    featuredMomdayVideo,
    vitalityBigMultiBanner,
    mallBannerCarousel,
    homeCategoryZone,
    homeGoodsShelfZone,
    homeActivityZone,
    homeChannelZone,
    homeCategoryIconSwiper,
    goodsTag,
    redPacketsRainPop
  },
  data() {
    var that = this
    return {
      index: 0,
      tagShow: false,
      signinShow: null,
      searchType: 0,
      bannerSwiper: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        },
        observer: true, // 监听DOM变化（loop克隆节点必备）
        observeParents: true,
        pagination: {
          el: '#bannerSwiperPagination',
          type: 'bullets'
        },
        on: {
          slideChangeTransitionStart: function () {
            that.activeIndex = this.realIndex
          },
          click: function () {
            var activeIndex = this.realIndex
            if (checkAgent() != 'Harmony') {
              that.bannerClick(
                that.newbannerlist[activeIndex],
                activeIndex,
                'banner-' + (activeIndex + 1)
              )
            }
          }
        }
      },
      seriesSwiper: {
        freeMode: true,
        autoplay: false,
        autoplayDisableOnInteraction: false,
        slidesPerView: 3,
        slidesPerGroup: 1,
        observer: true,
        observeParents: true,
        spaceBetween: 10,
        pagination: {
          el: '.seriesSwiperPagination',
          type: 'bullets'
        }
      },
      currscroll: 0,
      lastscroll: 0,
      isheaderwidth: 0,
      isheadertop: 0,
      defaultSearch: '',
      activeIndex: 0,
      videoplay: 0,
      is_private: 0,
      searchlist: [],
      newbannerlist: [],
      /** 分类下轮播 bannerZone：ad_title、img_path、ad_type、ad_target 等 */
      bannerZone: [],
      /** 频道专区 channelZone */
      channel_zone_list: [],
      notice: {},
      actcalendar: {},
      actseckill: {},
      fullgift: [],
      categorylist: [],
      /** 分类图标区：classic 原多行分页；row 单行每屏 5 个可左滑 + 底部指示点 */
      category_icon_layout: 'row',
      activitylist: [],
      privatesphere: [], // 私域导流入口
      privatefloat: {}, // 私域导流入口
      featuredads: [],
      actGoodsAd: [],
      videogoodslist: [],
      /** 大图多品轮播（唤醒元气等），对应接口 bigMultiBannerZone */
      bigMultiBannerZone: [],
      /** 分类专区横向滑动 categoryZone */
      categoryZone: [],
      /** 产品货架 goodsShelfZone */
      goodsShelfZone: [],
      /** 活动组合区 activityZone */
      activityZone: [],
      activityZoneProduct: {},
      serieslist: [],
      videoIndex: 0,
      goodsTransform: false,
      initialIndex: 0,
      seriesNames: [],
      salseranknavlist: [],
      salseranklist1: [],
      salseranklist2: [],
      salserank: 0,
      salserank1: -1,
      salserankheight: document.body.clientHeight - 57,
      isFixedSalserank: false,
      tagid: '',
      tabDisabled: false,
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 1,
      isWx: isWeixin() ? 1 : 0,
      is_pop: null,
      timeOneDay: false,
      pop50_img_url: '',
      pop50_ad_target: '',
      showCoupon: null, // 至臻券 优惠券弹窗
      coupon_ad_title: '', // 至臻券 埋点标题
      showcoupon0326: false, // 企微二维码弹窗
      five_fold_show: 0,
      showstatus: 3, // 新人有礼
      isnewuser: 0, // 是否是新人
      popup_ads: {},
      showquan: false,
      couponsendid: '',
      goldRainData: {}, // 2021-1-26金币雨活动
      goldRainSetTimeout: null,
      drainage: null,
      jhdzShow: 0, // 钜惠店主入口是否展示
      specialPopJSON: {
        ispop: 0, // 是否弹出
        poptimes: 0, // 弹出次数
        popads: {
          pop_img_url: '',
          pop_ad_type: 1,
          pop_ad_target: ''
        }
      },
      ord_popup_ads: null, // 首页普通弹窗
      info: null,
      showsku: false,
      issmspop: {
        ispop: 0,
        pop_img_url: ''
      },
      noticmsg: '',
      cartnum: 0,
      countdown: {
        time: 0,
        isshow: 0
      },
      isnewpersontask: 0,
      newpersonjumpurl: '',
      follow: null,
      skinInfo: {},
      birthday_pop: {},
      birthdayinfo_pop: {},
      orderwaitpay_pop: {}, // 订单待支付弹窗
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 3,
        observer: true,
        observeParents: true,
        spaceBetween: 4
      },
      act_countdown: {},
      stickShow: 0,
      isdrag: true,
      prepay_popup: {}, // 38预约活动弹窗
      communityad: {}, // 跳社区广告位
      momday_video: {},
      mall_endorsement: {}, // 商城首页-平台背书
      showNewPeople: false,
      newPeopleConfig: {},
      aestheticTasterPop: {}, // 生活美学品鉴官弹窗
      my_scroller: null,
      stickyShow: false,
      isRedPacketPop: 0, // 2025-09-02 红包雨弹窗
      isNewPage:-1, // 是否新版 0:否，1:是
      restrictedImg: {}, // 美客莱入口图
      ndiscount_welfare: {}, // 新人折扣福利弹窗配置
      ndiscountWelfareShow: false, // 新人折扣福利弹窗展示标志
      bg_topcolor: '' // 商城首页顶部背景色
    }
  },
  computed: {
    goods_shelf_flat_has_goods() {
      const z = this.goodsShelfZone
      const groups = (z && z.groupList) || []
      for (let i = 0; i < groups.length; i++) {
        const gl = groups[i].goodsList || []
        if (gl.length) return true
      }
      return false
    },
    activity_zone_valid() {
      const z = this.activityZone
      if (!z || !Object.keys(z).length) return false
      const left = z.leftBanner || []
      const ra = z.rightAd || {}
      const top = ra.topAd
      const bottomAd = ra.bottomAd || []
      const bb = ra.bottomBanner
      const bbl = bb && (bb.bannerList || []).length
      if (left.length || (top && top.img_path) || bbl || bottomAd.length) return true
      return false
    }
  },
  mounted() {
    this.my_scroller = this.$refs.my_scroller
    if (sessionStorage.getItem('popFlagBool50') == null) {
      sessionStorage.setItem('popFlagBool50', 1)
    }
    if (!localStorage.getItem('popFlagSub')) {
      localStorage.setItem('popFlagSub', 1)
    }
    if (!localStorage.getItem('popFlag50')) {
      localStorage.setItem('popFlag50', 1)
    }
    if (sessionStorage.getItem('oncePopupFlag') == null) {
      // 只有每次打开商城首页才能触发的弹框（从其他页面返回首页不算）
      sessionStorage.setItem('oncePopupFlag', 1)
    }
    var url = this.$ajax.actNotice_URL
    if (!getCookie('ckc4_act_notice')) {
      this.$customRequestAjax(url).then(function (res) {
        setCookie('ckc4_act_notice', 'actNotice', 5 * 60 * 1000)
      })
    }
    var that = this

    if (this.$route.query.pt === 'ckapp') {
      setCookie('wxmalltoken', this.$route.query.waptoken)
    }

    this.getData(() => {
      let tempTime = new Date('2025/09/21 23:59:59').getTime()
      let curTime = new Date().getTime()
      // 09.21日之前处理
      if (tempTime >= curTime && sessionStorage.getItem('homepage_to_giftbagproduct') != 1) {
        sessionStorage.setItem('homepage_to_giftbagproduct', 1)
        setTimeout(() => {
          window.location.href = '/giftBagProduct?id=542'
        }, 2000)
      }
      if (Object.keys(this.act_countdown).length) {
        this.countDown()
      }
      this.hasNewMsg('init')
      if (Number(this.isnewpersontask) == 1) {
        // 新用户顶部图片显示
        this.getNewPeople()
      }
    })
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter: function (to, from, next) {
    if (from.path == '/') {
      // 当前页面刷新不需要切换位置
      next(function (vm) {
        window.addEventListener('scroll', vm.scrollToTop)
        vm.getHeadData()
        fenxiang({ path: 'home' })
      })
    } else {
      next(function (vm) {
        window.addEventListener('scroll', vm.scrollToTop)
        vm.hasNewMsg()
        vm.getHeadData()
        fenxiang({ path: 'home' })
      })
    }
  },
  beforeRouteLeave: function (to, from, next) {
    this.videogoodslist.map((item) => {
      item.initialIndex = item.videoIndex
    })
    setCookie('iscloseAct', 1, 12 * 60 * 60 * 1000)
    window.removeEventListener('scroll', this.scrollToTop)
    next()
  },
  methods: {
    // swiper点击兼容鸿蒙系统
    swiperClickHandler(refName, ref_i) {
      const swiperEl =
        typeof ref_i == 'number' ? this.$refs[refName][ref_i].$el : this.$refs[refName].$el
      const eventType = checkAgent() == 'Harmony' ? 'click' : ''
      if (eventType) {
        swiperEl.addEventListener(eventType, (e) => {
          e.stopPropagation()
          const slideItem = e.target.closest('.swiper-slide')
          if (slideItem) {
            const id = slideItem.dataset.swiperSlideIndex
              ? parseInt(slideItem.dataset.swiperSlideIndex || 0)
              : parseInt(slideItem.getAttribute('data-swiper-slide-index') || 0)
            if (refName == 'bannerSwiper') {
              this.bannerClick(this.newbannerlist[id], id, 'banner-' + (id + 1))
            }
          }
        })
      }
    },
    dragStart: function (e) {
      this.isdrag = true
      this.tempX = parseInt($(e.currentTarget).css('left') + 0)
      this.tempY = parseInt($(e.currentTarget).css('top') + 0)
      this.x = e.touches[0].pageX
      this.y = e.touches[0].pageY
    },
    dragMove: function (e) {
      if (this.isdrag) {
        var curX = this.tempX + e.touches[0].pageX - this.x
        var curY = this.tempY + e.touches[0].pageY - this.y
        //边界判断
        curX = curX < 0 ? 0 : curX
        curY = curY < 0 ? 0 : curY
        curX =
          curX < document.documentElement.clientWidth - $(e.currentTarget).width()
            ? curX
            : document.documentElement.clientWidth - $(e.currentTarget).width()
        curY =
          curY < document.documentElement.clientHeight - 55 - $(e.currentTarget).height()
            ? curY
            : document.documentElement.clientHeight - 55 - $(e.currentTarget).height()
        $(e.currentTarget).css({ left: curX, top: curY })
        //禁止浏览器默认事件
        e.preventDefault()
      }
    },
    dragEnd: function () {
      this.isdrag = false
    },
    followFn: function (data) {
      this.follow = data
    },
    showSku: function (n) {
      this.showsku = n
    },
    search: function (item) {
      if (item.url) {
        window.location.href = item.url
      } else if (item.searchtext) {
        this.$router.push({
          path: '/searchlist',
          query: {
            searchval: encodeURIComponent(item.searchtext),
            searchType: this.searchType
          }
        })
      } else {
        this.$toast('请正确输入查询内容')
      }
    },
    countDown() {
      let nowtime = new Date().getTime(),
        starttime = new Date(this.act_countdown.starttime.replace(/-/g, '/')).getTime(),
        endtime = new Date(this.act_countdown.endtime.replace(/-/g, '/')).getTime()
      if (nowtime < starttime) {
        this.countdown.time = starttime - nowtime
        this.countdown.isshow = 1
      } else if (nowtime < endtime && nowtime >= starttime) {
        this.countdown.time = endtime - nowtime
        this.countdown.isshow = 2
      } else {
        this.countdown.isshow = 0
      }
    },
    finishFn() {
      this.countDown()
    },

    // 未读消息
    async hasNewMsg(type) {
      let { data } = await this.$customRequestAjax(this.$ajax.hasNewMsg_URL)
      this.tagShow = data.data.has_new_msg
      this.noticmsg = data.data.noticmsg
      this.cartnum = data.data.cartnum ? data.data.cartnum : 0
      if (data.data.act_status == 1) {
        this.showquan = true
      } else {
        this.showquan = false
      }
      if (type == 'init') this.ndiscountWelfarePop()
    },
    // 新人折扣福利弹窗（弹窗链入口，优先级最高；每次进首页复核条件命中即弹）
    ndiscountWelfarePop() {
      const welfare = this.ndiscount_welfare
      if (welfare && welfare.show == 1 && welfare.img) {
        this.is_pop = true // 占位阻断后续弹窗节点
        this.ndiscountWelfareShow = true
        return
      }
      this.getMeikelaiPop()
    },
    // 新人折扣福利弹窗-点击跳转（协定首页仅下发 clicktype=jump，jumplink 为完整 URL；整页跳转，不续跑弹窗链）
    goNdiscountWelfare() {
      if (this.ndiscount_welfare.clicktype != 'jump' || !this.ndiscount_welfare.jumplink) return
      this.ndiscountWelfareShow = false
      this.is_pop = false
      window.location.href = this.ndiscount_welfare.jumplink
    },
    // 新人折扣福利弹窗-关闭（释放 is_pop 占位，续跑弹窗链让后续弹窗正常展示）
    closeNdiscountWelfare() {
      this.ndiscountWelfareShow = false
      this.is_pop = false
      this.getMeikelaiPop()
    },
    // 美客莱入口
    async getMeikelaiPop(){
      if (this.restrictedImg && this.restrictedImg.imgUrl) {
        const meikelaiPop = {
          img_path: this.restrictedImg.imgUrl,
          ad_type: '0',
          pop_type: 'meikelaiPop',
          closeBtnHide: 1
        }
        this.is_pop = true
        this.popup_ads = meikelaiPop
      }
      if (!this.is_pop) {
        this.getYearReportPop()
      }
    },
    //年度分析报告首页弹窗
    async getYearReportPop(){
      let { data } = await this.$customRequestAjax(this.$ajax.getYearReportPop_URL)

      if (data.data.ispop == 1) {
        const yearReportPop = {
          ...data.data.popads,
          img_path: data.data.popads.img_url || '',
          pop_type: 'yearReportPop'
        }
        this.is_pop = true
        this.popType(100, yearReportPop, 'yearReportPop')
      }
      if (!this.is_pop) {
        this.redPacketPop()
      }
    },
    redPacketPop() {
      if (this.isRedPacketPop == 1 && !sessionStorage.getItem('isRedPacketPop_homePage')) {
        sessionStorage.setItem('isRedPacketPop_homePage', 1)
        this.$refs.redPacketsRainPop.open()
        return
      }
      this.birthdayPopInfo()
    },
    // async getQuanYiPopups() {
    //   let { data } = await this.$customRequestAjax(this.$ajax.getQuanYiPopups_URL)

    //   if (data.referralProgramPop.pop_img_url) {
    //     let referralProgramPop = {
    //       ...data.referralProgramPop,
    //       ad_type: '1',
    //       ad_target: data.referralProgramPop.url || '',
    //       img_path: data.referralProgramPop.pop_img_url || ''
    //     }
    //     this.popType(1, referralProgramPop, 'quanYiPop')
    //   }
    //   if (!this.is_pop) {
    //     this.birthdayPopInfo()
    //   }
    // },
    goquan: function () {
      this.$router.push('/getcoupon')
    },

    // 短信通知授权
    // async smsPop() {
    //   let { data } = await this.$customRequestAjax(this.$ajax.showMsgPop_URL)
    //   if (data.ispop) {
    //     this.popType(3, data, 'smsPop', () => {
    //       this.issmspop = Object.assign({}, this.issmspop, data)
    //     })
    //   }
    // },
    // async gosms(type) {
    //   let { data } = await this.$customRequestAjax.post(this.$ajax.doMsgPop_URL, {
    //     isagree: type
    //   })
    //   if (data.code == 200) {
    //     this.issmspop.ispop = 0
    //   }
    // },

    // 点击图片进行跳转
    specialPopFn(item) {
      if (item.pop_ad_target) window.location.href = item.pop_ad_target
    },
    // 企微二维码弹窗
    async specialPop() {
      let { data } = await this.$customRequestAjax(this.$ajax.getPopupInfo_URL)
      if (data.code === 200) {
        if (data.data.ispop == 1) {
          this.popType(parseInt(data.data.poptimes), data.data, 'specialPop', () => {
            this.specialPopJSON = Object.assign({}, this.specialPopJSON, data.data)
            this.showcoupon0326 = true
          })
        }
        if (!this.showcoupon0326) {
          this.getOrderCoupon()
        }
      } else {
        this.getOrderCoupon()
      }
    },

    // 2023-4-26 完善生日信息弹窗
    async birthdayPopInfo() {
      let { data } = await this.$customRequestAjax(this.$ajax.getUserBirthdayPop_URL)
      if (data.code === 200) {
        if (data.popup_ads.img_path) {
          this.birthdayinfo_pop = data.popup_ads
          this.popType(1, this.birthdayinfo_pop, 'birthdayinfo', null, 'month')
        }
        if (!this.is_pop) {
          this.birthdayPop()
        }
      } else {
        this.birthdayPop()
      }
    },
    // 2022-6-17 会员特权生日折扣弹窗
    birthdayPop() {
      this.popType(1, this.birthday_pop, 'birthday')
      if (!this.is_pop) {
        this.orderWaitPayPopInfo()
      }
    },
    // 2025-4-17 订单待支付提醒
    async orderWaitPayPopInfo() {
      let { data } = await this.$customRequestAjax(this.$ajax.getNotPayOrderPopup_URL)
      if (data.code === 200 && data.data && Object.keys(data.data).length > 0) {
        this.popType(2, data.data, 'orderwaitpay', () => {
          this.orderwaitpay_pop = { ...data.data, ispop: 1 }
        })
        if (!this.orderwaitpay_pop.ispop) {
          this.getCouponPopups()
        }
      } else {
        this.getCouponPopups()
      }
    },
    // 2025-06-12 专属优惠券弹窗-浏览商品送券
    async getCouponPopups() {
      let { data } = await this.$customRequestAjax(this.$ajax.getCouponPopupSet_URL)

      if (data.pop_up.img_path) {
        this.is_pop = true
        this.popup_ads = data.pop_up
      }
      if (!this.is_pop) {
        this.getNewInfo()
      }
    },
    detailsClick: function (items) {
      if ((items.isdeposit != 1 && items.issubscribeorder != 1) || items.isvirtual == 0) {
        this.$router.push({ path: '/orderdetails', query: { id: items.id } })
      }
    },
    closeWaitPay(type) {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'unpaypopup-cancel'
        }
      })
      if (type == 1) {
        localStorage.setItem('orderwaitpaypopFlag', 3)
      }
      this.orderwaitpay_pop.ispop = 0
    },

    goBuy: function () {
      if (this.orderwaitpay_pop.orderInfo.isoversea == 1 && isWx != 3) {
        download_dialog(this)
        return
      }
      this.$clickburiedPoint({
        data: {
          buttonCode: 'unpaypopup-order'
        }
      })
      sessionStorage.setItem('unpaypopup-pay', this.orderwaitpay_pop.orderInfo.id)
      if (this.orderwaitpay_pop.hasMore == 1) {
        this.$router.push('/myorder')
        this.$store.commit('ORDERLIST_NAVID', 1)
        return
      }
      this.$store.commit('ORDER_INIT_DATA', 1)
      if (this.orderwaitpay_pop.orderInfo.is_coupon == 1) {
        window.location.href =
          './static/wx/html/20190820/buyCoupon/pay.html?orderId=' +
          this.orderwaitpay_pop.orderInfo.id +
          '&m=' +
          this.orderwaitpay_pop.orderInfo.ordermoney
      } else {
        let skuids = []
        this.orderwaitpay_pop.orderInfo.itemlist.forEach(function (item) {
          skuids.push(item.skuid)
        })
        if (
          ((this.orderwaitpay_pop.orderInfo.isdeposit == 1 &&
            this.orderwaitpay_pop.orderInfo.finalpaystatus == 1) ||
            (this.orderwaitpay_pop.orderInfo.issubscribeorder == 1 &&
              this.orderwaitpay_pop.orderInfo.subscribepaystatus == 1)) &&
          this.orderwaitpay_pop.orderInfo.isvirtual == 1
        ) {
          var that = this
          var shopConfirmResult = {
            skuidArr: [],
            itemNum: [],
            skuidArrOversea: [],
            from: 2,
            orderfrom: 1,
            itemNumOversea: [],
            totalmoney:
              this.orderwaitpay_pop.orderInfo.finalpaymoney ||
              this.orderwaitpay_pop.orderInfo.ordermoney,
            totalnum: this.orderwaitpay_pop.orderInfo.item_nums,
            liveId: [],
            roomId: [],
            LiveIdArrOversea: [],
            roomIdArrOversea: [],
            ysorderid: this.orderwaitpay_pop.orderInfo.no
          }
          if (
            this.orderwaitpay_pop.orderInfo.issubscribeorder == 1 &&
            this.orderwaitpay_pop.orderInfo.subscribepaystatus == 1
          ) {
            shopConfirmResult = {
              skuidArr: [],
              from: 2,
              orderfrom: 3,
              itemNum: [],
              totalmoney: this.orderwaitpay_pop.orderInfo.ordermoney,
              totalnum: this.orderwaitpay_pop.orderInfo.item_nums,
              liveId: [],
              roomId: []
            }
          }
          this.orderwaitpay_pop.orderInfo.itemlist.forEach(function (item) {
            shopConfirmResult.skuidArr.push(item.skuid)
            shopConfirmResult.itemNum.push(item.num)
            shopConfirmResult.liveId.push(item.live_id ? item.live_id : '0')
            shopConfirmResult.roomId.push(item.room_id ? item.room_id : '0')
          })
          var urlCheck =
            that.$ajax.checkOrder_URL +
            '?skuids=' +
            shopConfirmResult.skuidArr.join() +
            '&buynum=' +
            shopConfirmResult.itemNum.join()
          if (
            this.orderwaitpay_pop.orderInfo.issubscribeorder == 1 &&
            this.orderwaitpay_pop.orderInfo.subscribepaystatus == 1
          ) {
            urlCheck =
              that.$ajax.checkOrder_URL +
              '?skuids=' +
              shopConfirmResult.skuidArr.join() +
              '&buynum=' +
              shopConfirmResult.itemNum.join() +
              '&type=2'
          }
          that.$customRequestAjax(urlCheck).then((res) => {
            if (res.data.code == 200) {
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              sessionStorage.removeItem('choose_integral')
              sessionStorage.removeItem('choose_coupon')
              sessionStorage.removeItem('choose_product')
              sessionStorage.removeItem('oversea_List')
              that.$router.push('/order')
            }
          })
        } else if (this.orderwaitpay_pop.orderInfo.is_drainage == 1) {
          this.$router.push({
            path: '/pay',
            query: {
              id: this.orderwaitpay_pop.orderInfo.id,
              money: this.orderwaitpay_pop.orderInfo.ordermoney,
              yl: 1,
              ann: 1,
              anncc: 1,
              skuids: JSON.stringify(skuids)
            }
          })
        } else {
          if (this.orderwaitpay_pop.orderInfo.isdeposit == 1) {
            if (this.orderwaitpay_pop.orderInfo.finalpaystatus == 0) return
            this.$router.push({
              path: '/pay',
              query: {
                id: this.orderwaitpay_pop.orderInfo.id,
                money: this.orderwaitpay_pop.orderInfo.ordermoney,
                skuids: JSON.stringify(skuids)
              }
            })
          } else {
            this.$router.push({
              path: '/pay',
              query: {
                id: this.orderwaitpay_pop.orderInfo.id,
                money: this.orderwaitpay_pop.orderInfo.ordermoney,
                skuids: JSON.stringify(skuids)
              }
            })
          }
        }
      }
    },
    // 2024-7-4 生活美学品鉴官弹窗
    // async aestheticTasterPopup() {
    //   let { data } = await this.$customRequestAjax(this.$ajax.getWhitePkWinPops_URL)
    //   this.aestheticTasterPop =
    //     data.aestheticTasterPop &&
    //     data.aestheticTasterPop.pop_img_url &&
    //     data.aestheticTasterPop.ispop
    //       ? {
    //           ...data.aestheticTasterPop,
    //           img_path: data.aestheticTasterPop.pop_img_url
    //         }
    //       : {}
    //   this.popType(2, this.aestheticTasterPop, 'aestheticTasterPop')
    //   if (!this.is_pop) {
    //     this.getNewInfo()
    //   }
    // },
    //  判断是否为新用户，显示新人客服二维码
    getNewPeople() {
      this.popType(2, this.newPeopleConfig, 'newPeoplePop', () => {
        this.showNewPeople = true
        this.newPeopleHeight = this.newPeopleConfig.img_list.reduce((acc, o) => {
          return acc + Number(o.img_height)
        }, 0)
        this.newPeopleHeight =
          (this.newPeopleHeight *
            (document.documentElement.clientWidth || document.body.clientWidth)) /
          750
        this.$commonburiedPoint({
          data: { isnewperson: 1 }
        })
      })
    },
    // 判断是否为新用户 新人有礼弹窗
    getNewInfo: function () {
      this.prepayPopup()
    },
    prepayPopup: function () {
      if (Object.keys(this.prepay_popup).length > 0) {
        this.popType(3, this.prepay_popup, 'prepayPop')
      } else {
        this.ordPopFn()
      }
    },

    // 订单发券弹窗:有新发的券则显示
    getOrderCoupon: function () {
      var that = this
      var url = this.$ajax.getOrderCoupon_URL
      try {
        this.$customRequestAjax(url).then(function (res) {
          if (res.data.code === 200) {
            if (res.data.coupon_id) {
              that.coupon_ad_title = res.data.ad_title || ''
              that.handleCouponId(res.data.coupon_id)
              that.goXcxCreateBtnFn()
            }
          }
        })
      } catch (e) {
        // that.smsPop()
      }
    },
    handleCouponId(couponId) {
      let oldCouponId = localStorage.getItem('couponId')
      if (!oldCouponId) {
        this.showCoupon = true
        localStorage.setItem('couponId', couponId)
      } else if (oldCouponId != couponId) {
        this.showCoupon = true
        localStorage.setItem('couponId', couponId)
      }
    },

    getHeadData: function () {
      var that = this
      var urlHead = this.$ajax.getTopMessage_URL
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken != this.waptoken.tourists) {
          this.$customRequestAjax(urlHead).then(function (res) {
            if (res.data.code == 200) {
              that.signinShow = res.data ? res.data.is_signin : null
              localStorage.setItem('ckc4_home_top_message', JSON.stringify(res.data))
              setCookie('ckc4_home_top_message', 'topMessage', 2 * 60 * 60 * 1000)
            }
          })
        }
      } else {
        this.$customRequestAjax(urlHead).then(function (res) {
          if (res.data.code == 200) {
            that.signinShow = res.data ? res.data.is_signin : null
            localStorage.setItem('ckc4_home_top_message', JSON.stringify(res.data))
            setCookie('ckc4_home_top_message', 'topMessage', 2 * 60 * 60 * 1000)
          }
        })
      }
    },
    newpersontask: function () {
      window.location.href = this.newpersonjumpurl
    },
    getData(fn) {
      let url = this.$ajax.getIndex_URL + '?isNewVersion=1'
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.isNewPage = res.data.isNewPage ? res.data.isNewPage : 0
          this.bg_topcolor = res.data.bg_topcolor ? res.data.bg_topcolor : ''
          this.skinInfo = res.data.ndoresult ? res.data.ndoresult : {}
          this.act_countdown =
            res.data.act_countdown && Object.keys(res.data.act_countdown).length
              ? res.data.act_countdown
              : {}
          this.isnewpersontask = res.data.isnewpersontask ? res.data.isnewpersontask : 0
          this.newPeopleConfig = res.data.newperson_info ? res.data.newperson_info : {}
          this.newpersonjumpurl = res.data.newpersonjumpurl ? res.data.newpersonjumpurl : ''
          this.is_private = res.data.is_private ? res.data.is_private : 0
          this.searchlist = res.data.searchList
          this.newbannerlist = res.data.newbannerlist || []
          this.bannerZone = Array.isArray(res.data.bannerZone) ? res.data.bannerZone : []
          this.channel_zone_list = Array.isArray(res.data.channelZone)
            ? res.data.channelZone
            : []
          this.notice = res.data.notice || {}
          this.actcalendar = res.data.actcalendar || {}
          this.actseckill = res.data.actseckill || {}
          this.fullgift = res.data.fullgift && Array.isArray(res.data.fullgift) ? res.data.fullgift : []
          this.categorylist = res.data.categorylist
          this.activitylist = res.data.activitylist
          this.privatesphere = res.data.privatesphere ? res.data.privatesphere : []
          this.communityad = res.data.communityad ? res.data.communityad : {}
          this.featuredads = res.data.featuredads
          this.actGoodsAd = res.data.actGoodsAD || {}
          this.privatefloat = res.data.privatefloat ? res.data.privatefloat : {}
          this.momday_video = res.data.momday_video ? res.data.momday_video : {}
          this.mall_endorsement = res.data.mall_endorsement ? res.data.mall_endorsement : {}
          this.isRedPacketPop = res.data.isRedPacketPop || 0
          var videogoodslist = res.data.videonewgoods.map((item) => {
            item.videoIndex = 0
            item.goodsTransform = false
            item.videoplay = 0
            item.initialIndex = 0
            item.goodsList.map((goodsItem) => {
              goodsItem.is_play = 1
            })
            return item
          })
          this.videogoodslist = videogoodslist
          this.bigMultiBannerZone = Array.isArray(res.data.bigMultiBannerZone) ? res.data.bigMultiBannerZone : []
          this.categoryZone = Array.isArray(res.data.categoryZone) ? res.data.categoryZone : []
          this.goodsShelfZone = Array.isArray(res.data.goodsShelfZone) ? res.data.goodsShelfZone : []
          this.activityZone = Array.isArray(res.data.activityZone) ? res.data.activityZone : []
          this.serieslist = res.data.serieslist
          for (var i = 0; i < this.serieslist.length; i++) {
            this.seriesNames.push(i)
          }
          this.$nextTick(() => {
            setTimeout(() => {
              this.stickyShow = true
            }, 100)
            this.seriesNames = []
            this.$nextTick(() => {
              zymedia('.video_banner', {
                aspectRation: '353' / '280',
                videoWidth: '353px',
                videoHeight: '280px',
                preload: 'auto',
                autoLoop: true,
                autoplay: true,
                hideVideoControlsOnLoad: true,
                enableFullscreen: false,
                enableVisibilityState: false,
                success(data) {}
              })
            })
          })
          this.salseranknavlist = res.data.tagslist
          this.defaultSearch = res.data.default_search ? res.data.default_search : ''
          if (this.defaultSearch) this.$store.commit('DEFAULT_SEARCH', this.defaultSearch)
          this.ord_popup_ads = res.data.popup_ads
          this.birthday_pop = res.data.birthday_popup_ads
          this.prepay_popup = res.data.prepay_popup
          this.restrictedImg = res.data.restrictedImg || {}
          this.ndiscount_welfare = res.data.ndiscount_welfare || {}
          if (this.salseranknavlist.length) {
            this.tagid = this.salseranknavlist[this.salserank].tagid
            this.getGuessData()
          } else {
            this.loading = false
            this.finished = true
          }
          if (typeof fn == 'function') fn()
          window.addEventListener('scroll', this.scrollToTop)
          this.$nextTick(() => {
            this.swiperClickHandler('bannerSwiper')
            if (this.$refs.activityStagger) {
              this.$refs.activityStagger.bindHarmonySwiper()
            }
            if (this.$refs.homeVideoGoods) {
              this.$refs.homeVideoGoods.bindVideoSwiperHarmony()
            }
          })
        }
      })
    },
    momdayPlayInitFromRoot() {
      if (this.$refs.featuredMomdayVideo) {
        this.$refs.featuredMomdayVideo.momdayPlay('init')
      }
    },
    // 首页普通弹窗
    ordPopFn: function () {
      // that.currentPopType => 当前接口返回的是那种弹框类型 0-普通弹框 1-vip礼包弹框
      // 如果是普通弹框，每天弹1次

      let curTime = new Date().getTime(),
        type = 'ordPop'

      if (this.ord_popup_ads.dateConfig) {
        this.ord_popup_ads.dateConfig.map((item) => {
          let time0 = new Date(item.date[0].replace(/-/g, '/')).getTime(),
            time1 = new Date(item.date[1].replace(/-/g, '/')).getTime()
          if (time0 < curTime && curTime <= time1) {
            if (!localStorage.getItem(type + time0)) {
              clearPopCache(type)
              localStorage.setItem(type + time0, 1)
            }
            this.popType(item.times, this.ord_popup_ads, type) // 设为100 原意为 需求：不限制次数
          } else {
            localStorage.removeItem(type + time0)
          }
        })
      } else {
        this.popType(3, this.ord_popup_ads, type) // 设为100 原意为 需求：不限制次数
      }
      if (!this.is_pop) {
        this.specialPop()
      }
    },
    popType: function (popNum, popup_ads, type, callback, timetype) {
      var that = this
      popType(
        popNum,
        popup_ads,
        type,
        callback,
        function () {
          that.is_pop = true
          that.popup_ads = popup_ads
        },
        function () {
          if (that.noticmsg) {
            that.$toast(that.noticmsg)
          }
        },
        timetype
      )
      that.goXcxCreateBtnFn()
    },
    doSort(index, list) {
      if (index < list.length) {
        if (this.nowPage == 1 && (index == 0 || index == 1)) {
          if (index == 0) {
            this.salseranklist1 = [list[index]]
          } else if (index == 1) {
            this.salseranklist2 = [list[index]]
          }
        } else {
          if (this.$refs.listItem1.clientHeight <= this.$refs.listItem2.clientHeight) {
            this.salseranklist1.push(list[index])
          } else {
            this.salseranklist2.push(list[index])
          }
        }
        if (index < list.length - 1) {
          this.loading = true
        } else {
          this.tabDisabled = false
          this.loading = false
        }
        let that = this
        this.$nextTick(() => {
          setTimeout(() => {
            that.doSort(index + 1, list)
          }, 100)
        })
      }
    },
    onInfinite: function () {
      if (!this.salseranknavlist.length) return
      this.tagid = this.salseranknavlist[this.salserank].tagid
      this.loading = true
      this.finished = false
      var that = this
      that.nowPage++
      that.getGuessData()
    },
    salserankClick(name) {
      if (this.salserank1 == name) return
      this.$clickburiedPoint({
        data: {
          buttonCode: 'itemclass-' + (this.salserank + 1)
        }
      })
      this.salserank1 = this.salserank = name
      this.tagid = this.salseranknavlist[this.salserank].tagid
      this.nowPage = 0
      this.salseranklist1 = []
      this.salseranklist2 = []
      this.onInfinite()
    },
    getGuessData() {
      this.tabDisabled = true
      let url =
          this.$ajax.getRecommend_URL +
          '?pageno=' +
          this.nowPage +
          '&pagesize=' +
          this.pagesize +
          '&tagid=' +
          this.tagid,
        that = this
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          let salseranklist = []
          if (this.nowPage == 1) {
            this.salseranklist1 = []
            this.salseranklist2 = []
            var rank_itemlist = Array.isArray(res.data.itemlist) ? res.data.itemlist : []
            if (this.activityZone.length && !Object.keys(this.activityZone[this.activityZone.length - 1].rightAd || {}).length && this.salseranknavlist.length == 1 && rank_itemlist.length) {
              this.activityZoneProduct = rank_itemlist[0]
              salseranklist = rank_itemlist.slice(1)
            } else {
              this.activityZoneProduct = {}
              salseranklist = rank_itemlist
            }
            this.refresh = false
          } else {
            salseranklist = res.data.itemlist
          }
          if (res.data.itemlist.length < this.pagesize) {
            this.finished = true
            if (this.nowPage == 1 && !salseranklist.length) {
              this.salseranklist1 = []
              this.salseranklist2 = []
            }
          } else {
            this.finished = false
          }
          if (salseranklist.length <= 0) {
            that.tabDisabled = false
          } else {
            that.$nextTick(() => {
              setTimeout(() => {
                that.doSort(0, salseranklist)
              }, 100)
            })
          }
        }
      })
    },
    goDetail: function (item, index, flowArea, name) {
      this.$clickburiedPoint({
        data: {
          buttonCode: flowArea
        },
        callback: () => {
          this.$clickburiedPoint({
            url: 'ckysdatacenter/itemclick/save',
            data: {
              itemid: item.item_id,
              scenepoint: 'MAIN',
              scenedesc: name
            }
          })
          this.$router.push({
            path: 'productdetail',
            query: {
              itemid: item.item_id
            }
          })
        }
      })
    },
    bannerClick: function (items, index, flowArea) {
      bannerClick(items, index, flowArea, this, () => {
        this.dataCollection(items, index, flowArea)
      })
    },
    goSignin: function () {
      this.$router.push({
        path: '/integral'
      })
    },
    // 跳转消息中心
    goMessage: function () {
      // 登录校验
      if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
        this.$router.push({
          path: '/login',
          query: {
            routeval: ''
          }
        })
      } else {
        this.$router.push('/messagecenter')
      }
    },
    // 跳转搜索
    searchClick: function () {
      this.$router.push('/search')
    },
    groupQr: function () {
      this.$clickburiedPoint({
        data: {
          buttonCode: 'ToChat'
        }
      })
      setTimeout(function () {
        window.location = '/static/wx/html/groupqrcode.html'
      }, 100)
    },
    stick: function () {
      var that = this
      setTimeout(function () {
        that.jump(document.querySelectorAll('.stick'))
      })
    },
    goSkinTest() {
      // 皮肤测试
      if (this.skinInfo.orderid) {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'skin'
          },
          callback: () => {
            this.$router.push({
              path: '/analysisDetail',
              query: {
                orderid: this.skinInfo.orderid,
                sex: this.skinInfo.sex,
                source: 'records'
              }
            })
          }
        })
      } else {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'skin'
          },
          callback: () => {
            this.$router.push('/skinAnalysis')
          }
        })
      }
    },
    // 点击滚动
    jump: function (dom) {
      var jump = dom
      var total = jump[0].offsetTop - 54
      var distance =
        parseInt(document.body.scrollTop) || parseInt(document.documentElement.scrollTop)
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      if (total > distance) {
        smoothDown()
      } else {
        smoothUp()
      }
      function smoothDown() {
        var step = total / 10
        if (distance < total) {
          distance += step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothDown, 30)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
      function smoothUp() {
        var newTotal = distance - total
        var step = newTotal / 5
        if (distance > 0) {
          distance -= step
          document.body.scrollTop = distance
          document.documentElement.scrollTop = distance
          setTimeout(smoothUp, 30)
        } else {
          document.body.scrollTop = total
          document.documentElement.scrollTop = total
        }
      }
    },
    // 客服
    keFu: function () {
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: ''
            }
          })
        } else {
          this.$clickburiedPoint({
            data: {
              buttonCode: 'ToSer'
            }
          })
          setTimeout(function () {
            Func()
          }, 100)
        }
      } else {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'ToSer'
          }
        })
        setTimeout(function () {
          Func()
        }, 100)
      }
      var Func = () => {
        qrcodeKefuLimits(1).then(() => {
          kefu()
        })
      }
    },
    goXcxCreateBtnFn: function () {
      var that = this
      setTimeout(function () {
        goXcxCreateBtnFn(that, 'index')
      }, 500)
    },
    loadstart(e) {},
    scrollTopHeader(scroll) {
      scroll.scrollTop = scroll.scrollTop - (this.newPeopleHeight || 0)
      if (Number(scroll.scrollTop) >= 0) {
        this.currscroll = scroll.scrollTop
        this.stickShow = document.documentElement.clientHeight <= this.currscroll ? 1 : 0
        let scrollheight = 102
        if (
          scrollheight / 4 < scroll.scrollTop &&
          scrollheight / 2 >= scroll.scrollTop &&
          this.currscroll >= this.lastscroll &&
          this.lastscroll != 0
        ) {
          this.isheaderwidth = 1
          this.isheadertop = 0
        } else if (scrollheight / 2 < scroll.scrollTop) {
          this.isheaderwidth = 1
          this.isheadertop = 1
        } else if (
          scrollheight / 4 < scroll.scrollTop &&
          scrollheight / 2 >= scroll.scrollTop &&
          this.currscroll < this.lastscroll
        ) {
          this.isheadertop = 0
          this.isheaderwidth = 1
        } else if (scrollheight / 4 >= scroll.scrollTop) {
          this.isheadertop = 0
          this.isheaderwidth = 0
        }
        this.lastscroll = scroll.scrollTop
      }
    },
    scrollTopSalserank(scroll) {
      if (this.salseranknavlist.length>1) {
        this.isFixedSalserank = scroll.isFixed
      }
    },
    scrollToTop() {
      if (this.$refs.homeVideoGoods) {
        this.$refs.homeVideoGoods.onWindowScroll()
      }
    },
    dataCollection(items, index, flowArea) {
      let params = {
        flowArea_var: flowArea, // 区域
        position_var: index, // 坑位
        flowName_var: flowArea == '热门直播' ? items.name : items.ad_title || '', // 流量位名称
        productName_var: flowArea == '热门直播' ? '' : items.name || '' // 商品名称
      }

      // 首页-流量位-埋点事件
      gio('track', 'flowLocationClick', params)
      // 首页-流量位-区域-转化变量
      gio('evar.set', 'flowArea_evar', flowArea)
      // 首页-流量位-区域-坑位-转化变量
      let value = flowArea == '热门直播' ? items.name : items.ad_title || ''
      gio('evar.set', 'flowName_evar', value)
    },
    goAct: function (flowArea) {
      this.closeAct()
      if (this.popup_ads.pop_type == 'meikelaiPop') return
      this.bannerClick(this.popup_ads, 0, flowArea)
    },
    // 跳转至优惠券列表页
    goCouponList() {
      this.closeCoupon()
      this.$clickburiedPoint({
        data: {
          buttonCode: 'indexpopup',
          buttontext: (this.coupon_ad_title || '') + '-1'
        },
        callback: () => {
          this.$router.push('/cashcoupon')
        }
      })
    },
    // 跳转至分类页
    goShopping() {
      this.closeCoupon()
      this.$clickburiedPoint({
        data: {
          buttonCode: 'indexpopup',
          buttontext: (this.coupon_ad_title || '') + '-2'
        },
        callback: () => {
          this.$router.push('/classification')
        }
      })
    },
    // 关闭产品券弹窗
    closeCoupon() {
      this.showCoupon = !this.showCoupon
    },
    closeAct: function () {
      if (!this.popup_ads || this.popup_ads.closeBtnHide != 1) {
        this.is_pop = false
      }
      this.showAct = false
      this.momdayPlayInitFromRoot()
    }
  }
}
</script>

<style scoped lang="scss">
.new-people-wrap {
  width: 100%;
  position: relative;
  img {
    width: 100%;
    height: auto;
  }
  .code-img {
    width: 18%;
    position: absolute;
    top: 12.5%;
    left: 59.8%;
  }
}
.index {
  /*padding-bottom: 0.57rem;*/
  .my_scroller {
    position: relative;
  }
  .sticky {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }
  .header {
    padding: 0 0 0.04rem;
    background: linear-gradient(
      180deg,
      rgba(109, 106, 106, 0.4) 0%,
      rgba(109, 106, 106, 0.1) 70%,
      rgba(109, 106, 106, 0) 100%
    );
    position: relative;
    z-index: 99;
    &.headerheight {
      background: #fea9ae;
      min-height: 0.44rem !important;
    }
    .headsearch {
      width: 100%;
      top: 0;
      transition: all 0.2s;
      padding: 0 0.11rem;
      &.headsearchwidth {
        width: 70%;
        top: -0.33rem;
      }
    }
  }
  .header_content,
  .header_content .icon,
  .hot,
  .hot li {
    display: flex;
  }
  .header_content {
    justify-content: space-between;
  }
  .header_content,
  .hot,
  .hot li {
    align-items: center;
  }
  .header_content {
    padding: 0.08rem 0.11rem 0.08rem;
    // background: #fea9ae;
    span {
      color: #ffffff;
      font-size: 0.14rem;
      opacity: 1;
      transition: all 0.2s;
      background: transparent;
      &.opac {
        opacity: 0;
        background: #fea9ae;
      }
    }
    .icon {
      img {
        width: 0.24rem;
        height: 0.24rem;
        margin-left: 0.12rem;
      }
    }
  }
  .headsearch .inp {
    margin-right: 0;
  }
  .hot {
    margin-top: 0.04rem;
    flex-wrap: wrap;
    opacity: 1;
    transition: all 0.2s;
    padding: 0 0.11rem;
    &.opac {
      margin-top: -2rem;
      opacity: 0;
    }
    li {
      margin-left: 0.1rem;
      color: #ffffff;
      font-size: 0.1rem;
      img {
        width: 0.09rem;
        height: 0.09rem;
        margin-right: 0.03rem;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .banner {
    margin-top: -0.01rem;
    position: relative;
    border-radius: 0 0 100% 100%;
    height: 2.54rem;
    .swiper-wrapper {
      .swiper-slide {
        overflow: hidden;
        height: 2.54rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    ul {
      padding: 0.51rem 0.1rem 0;
      box-sizing: border-box;
      li {
        overflow: hidden;
        border-radius: 0.04rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .countdown {
    margin: 0.1rem 0.11rem;
    position: relative;
    img {
      width: 100%;
    }
    .van-count-down {
      padding-left: 13%;
      padding-right: 15%;
      position: absolute;
      bottom: 13%;
      width: 100%;
    }
    .time {
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.12rem;
      .colon {
        display: block;
        width: 0.45rem;
        height: 0.44rem;
        /*background: url(/static/images/block.png?v=1) no-repeat center;*/
        background-size: 100%;
        text-align: center;
        line-height: 0.44rem;
        color: #d64556;
        font-size: 0.28rem;
        margin-right: 0.02rem;
      }
    }
  }
  .featuredads {
    margin: 0.1rem 0.11rem 0;
    border-radius: 0.1rem;
    overflow: hidden;
    &.mall_endorsement {
      border-radius: 0;
    }
    img {
      width: 100%;
    }
  }
  .skinText {
    margin: 0.1rem 0 0;
  }
  .series {
    margin-top: 0.1rem;
    .title {
      img {
        height: 0.95rem;
        border-radius: 0.12rem;
      }
    }
    img {
      width: 100%;
    }
  }
  .salserank {
    position: relative;
    z-index: 99;
    background: #f5f5f5;
    .salseranknav {
      text-align: center;
      p {
        color: #333333;
      }
      span {
        color: #999999;
        border-radius: 0.1rem;
        display: inline-block;
        padding: 0.01rem 0.05rem;
        margin-top: 0.01rem;
      }
    }
    .list {
      width: 100%;
      padding-right: 0.1rem;
      overflow: hidden;
      margin-top: 0;
      transition: all 0.4s;
      .listItem {
        padding-left: 0.1rem; // 剧中
        width: 50%;
        float: left;
      }
    }
  }
  #bannerSwiperPagination,
  .seriesSwiperPagination {
    width: auto;
    font-size: 0;
    color: #ffffff;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
  }
  .floatBtn {
    position: fixed;
    right: 0.17rem;
    bottom: 0.89rem;
    background: transparent;
    z-index: 2001;
    .imgLive {
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    img,
    .imgLive {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      &:first-of-type {
        margin-bottom: 0.04rem;
      }
    }
  }
  .floatadvert {
    position: fixed;
    right: 0;
    z-index: 2001;
    overflow: hidden;
    img {
      width: 0.7rem;
    }
  }

  /*弹窗*/
  .pop-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .content-wrap {
      z-index: 10001;
      box-sizing: border-box;
      width: 2.72rem;
      height: 2.75rem;
      background: #fff;
      border-radius: 0.12rem;
      text-align: center;
      line-height: 0.32rem;
      .logo {
        display: block;
        margin: 0.2rem auto 0.15rem;
        width: 0.8rem;
        height: 0.8rem;
      }
      .name {
        color: #c9ab6d;
        font-size: 0.23rem;
        font-weight: bold;
      }
      .label {
        color: #fc0324;
        font-size: 0.15rem;
        margin: 0.1rem 0.27rem 0.18rem;
        line-height: 0.21rem;
      }
      .footer-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.23rem;
        div {
          width: 1.04rem;
          height: 0.31rem;
          line-height: 0.31rem;
          box-sizing: border-box;
          text-align: center;
          font-size: 0.12rem;
          border-radius: 0.16rem;
          &.btn-see {
            color: #fc0324;
            border: 0.01rem solid #fc0324;
          }
          &.btn-buy {
            color: #fff;
            background: #fc0324;
          }
        }
      }
    }
  }
  .block {
    &.positionblock {
      .img {
        position: relative;
        p {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0.75rem;
          font-size: 0.11rem;
          color: #f8f7f7;
          text-align: center;
        }
      }
    }
    .couponget {
      width: 60%;
      margin: 0 auto;
    }
  }
  // 金币雨专用
  .block1 {
    width: 100%;
    background-color: transparent;
    text-align: center;
    font-size: 0;
    position: static;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .van-icon-close {
    margin-top: 0.4rem;
    font-size: 30px;
    color: #fff;
  }
  .sharecontainer {
    position: fixed;
    width: 100%;
    z-index: 100;
    height: 100%;
    left: 0;
    top: 0;
  }
  .sharecontainer img {
    position: absolute;
    top: 0.2rem;
    right: 0.73rem;
    width: 1.53rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .sharecontainer .know {
    width: 1.09rem;
    height: 0.36rem;
    line-height: 0.36rem;
    color: #fff;
    border-color: #fff;
    background: transparent;
    position: absolute;
    bottom: 1.5rem;
    left: 50%;
    margin-left: -0.54rem;
  }
  .couponpopup .img {
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    width: 80%;
  }
  .couponpopup .close {
    right: 5%;
    top: 63%;
    color: #ffffff;
  }
  .couponpopup img {
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    width: 97%;
  }
  .couponpopup .img img {
    position: initial;
    width: 100%;
    transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    -o-transform: translate(0, 0);
  }
  .couponpopup .couponget {
    width: 60%;
  }
  .couponpopup .couponget.couponget1 {
    width: 80%;
  }
  .couponpopup .know {
    width: auto;
    height: auto;
    left: 50%;
    margin-left: -0.15rem;
  }
  .couponpopup p {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0.75rem;
    font-size: 0.11rem;
    color: #f8f7f7;
    text-align: center;
  }
}
.product {
  margin-top: 0.16rem;
  position: relative;
  background: #f8f8f8;
  border-radius: 0.08rem;
  .productBox {
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    .img {
      position: relative;
      img {
        &:first-of-type {
          width: 100%;
          height: 100%;
        }
      }
      width: 0.6rem;
      height: 0.6rem;
    }
    .proContent {
      margin-left: 0.07rem;
      margin-top: 0.08rem;
      flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -ms-flex: 1;
      -o-flex: 1;
      > b {
        font-size: 0.13rem;
        font-weight: 400;
        color: rgba(41, 41, 41, 1);
        line-height: 0.18rem;
        display: block;
        margin-bottom: 0.05rem;
      }
      > p {
        align-items: flex-start;
        -moz-align-items: flex-start;
        -ms-align-items: flex-start;
        -webkit-align-items: flex-start;
        -o-align-items: flex-start;
        > b {
          font-size: 0.11rem;
          font-weight: 400;
          color: rgba(108, 108, 108, 1);
          line-height: 0.16rem;
          display: block;
        }
      }
    }
  }
  .totalPrice {
    position: absolute;
    right: -0.02rem;
    z-index: 10;
    opacity: 0.85;
    height: 0.6rem;
    padding-right: 0.06rem;
    display: flex;
    display: -webkit-flex;
    display: -o-flex;
    display: -ms-flex;
    display: -moz-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
    -moz-flex-direction: column;
    justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    -ms-justify-content: center;
    -moz-justify-content: center;
    &.totalPriceShadow {
      background: rgba(255, 255, 255, 1);
      box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
      -webkit-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
      -moz-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
      -ms-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
      -o-box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
    }
    & + .totalPriceNoShadow {
      background: rgba(255, 255, 255, 1);
    }
    .price {
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      align-items: flex-end;
      -webkit-align-items: flex-end;
      -o-align-items: flex-end;
      -ms-align-items: flex-end;
      -moz-align-items: flex-end;
      font-size: 0.14rem;
      font-weight: 600;
      color: #222222;
      line-height: 0.14rem;
      &:before {
        content: '￥';
        font-size: 0.1rem;
        font-weight: 600;
        line-height: 0.14rem;
      }
      i {
        font-size: 0.11rem;
        font-style: normal;
        line-height: 0.14rem;
      }
    }
    > b {
      color: #908d8d;
      font-size: 0.11rem;
      line-height: 0.16rem;
      display: block;
      font-weight: 400;
      text-align: center;
      white-space: nowrap;
    }
  }
  .bestSellingSwiper {
    /*padding-right: 0.6rem;*/
    width: 100%;
    .swiper-container {
      padding-right: 0.7rem;
      .swiper-wrapper {
        padding: 0.06rem 0.1rem;
        > .swiper-slide {
          width: 0.6rem;
          position: relative;
          background-color: white;
          .img {
            width: 0.6rem;
            height: 0.6rem;
            position: relative;
            .tag {
              position: absolute;
              right: 0;
              top: 0;
              font-size: 0.12rem;
              .van-tag {
                border-radius: 0px 0px 0px 2px;
              }
            }
            img {
              &:first-of-type {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.bestSellingSwiper {
  .swiper-container {
    .swiper-wrapper {
      padding: 0.1rem 0.06rem;
    }
  }
}
.index {
  .banner {
    .swiper-container {
      margin: 0;
      width: 100%;
      .swiper-wrapper {
        box-sizing: border-box;
      }
    }
    #bannerSwiperPagination {
      bottom: 0.1rem;
      span {
        margin-left: 0.05rem;
        &.swiper-pagination-bullet {
          width: 0.05rem;
          height: 0.05rem;
          border-radius: 50%;
          background: #ffffff;
          opacity: 1;
        }
        &:first-child {
          margin-left: 0;
        }
        &.swiper-pagination-bullet-active {
          background: #fc0324;
        }
      }
    }
  }
  .series {
    .van-cell {
      background: transparent;
      padding: 0 0.11rem 0.1rem;
      .van-cell__right-icon {
        display: none;
      }
    }
    .van-collapse-item__content {
      background: transparent;
      padding: 0 0.11rem 0.26rem;
    }
    .seriesgoods {
      position: relative;
    }
  }
  .salserank {
    &.salserankheight {
      min-height: 6.67rem;
    }
    &.salserankBack {
      .van-sticky--fixed {
        /*bottom: 0;*/
        /*padding-bottom: 0.5rem;*/
        z-index: 2000;
        /*overflow: hidden;*/
      }
      .van-tabs__nav {
        background: #ffffff;
        /*padding-top: 0.06rem;*/
      }
      .list {
        padding-top: 0.1rem;
        overflow: auto;
        height: 92%;
      }
    }
    .van-tabs--line .van-tabs__wrap {
      height: 0.58rem;
      padding-bottom: 0.14rem;
    }
    &.salserank-empty .van-tabs--line .van-tabs__wrap {
      height: 0;
      padding-bottom: 0;
    }
    .van-tabs__nav {
      background: #f5f5f5;
      padding: 0.06rem 0 0.12rem;
      .van-tab {
        .salseranknav {
          p {
            font-weight: bold;
          }
        }
      }
      .van-tab--active {
        .salseranknav {
          p {
            color: #fc0324;
          }
          span {
            color: #fc0324;
            background: #f5dce0;
          }
        }
      }
      .van-tabs__line {
        display: none;
      }
      > div:nth-last-of-type(2) {
        padding-right: 0.11rem;
      }
    }
    .van-tab {
      padding: 0 0.14rem;
      &:first-of-type {
        padding-left: 0.11rem;
      }
    }
  }
  .slide_cl_xcx, .slide_cl_app {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
  }
  .seriesSwiperPagination {
    span {
      &.swiper-pagination-bullet {
        width: 0.11rem;
        height: 0.02rem;
        border-radius: 0.01rem;
        margin: 0 !important;
        background: #cccccc;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
  #bannerSwiperPagination,
  .seriesSwiperPagination {
    text-align: center;
    span {
      margin-left: 0.05rem;
      background: rgba(0, 0, 0, 0.2);
      &.swiper-pagination-bullet-active {
        background: #fc0324;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/homePage.vue